import HotelList from "../components/HotelList";
import { Helmet } from "react-helmet-async";

export default function Hotels() {
    return (

        <>
            <Helmet>
                <title>
                    Hotels in Dubai | Dubai Cheap Hotels
                </title>

                <meta
                    name="description"
                    content="Browse cheap hotels, budget stays, apartments, and affordable accommodations in Dubai with Dubai Cheap Hotels."
                />

                <link
                    rel="canonical"
                    href="http://127.0.0.1:8000/hotels"
                />

                {/* Open Graph */}
                <meta
                    property="og:title"
                    content="Hotels in Dubai | Dubai Cheap Hotels"
                />

                <meta
                    property="og:description"
                    content="Browse cheap hotels, budget stays, apartments, and affordable accommodations in Dubai with Dubai Cheap Hotels."
                />

                <meta
                    property="og:url"
                    content="http://127.0.0.1:8000/hotels"
                />

                <meta
                    property="og:type"
                    content="website"
                />

                {/* Twitter */}
                <meta
                    name="twitter:card"
                    content="summary_large_image"
                />

                <meta
                    name="twitter:title"
                    content="Hotels in Dubai | Dubai Cheap Hotels"
                />

                <meta
                    name="twitter:description"
                    content="Browse cheap hotels, budget stays, apartments, and affordable accommodations in Dubai with Dubai Cheap Hotels."
                />

                <meta
                    name="robots"
                    content="index, follow"
                />
            </Helmet>

            <div>
                <HotelList showSidebar={true} showBanner={true} showHeading={false} />
            </div>
        </>
    );
}